const quantityWord = (benefit: App.LoyaltyRegionTierBenefit, count: number): string =>
  benefit.unlimited ? 'Unlimited' : String(count)

export function formatBenefitLabel(
  benefit: App.LoyaltyRegionTierBenefit,
): string | undefined {
  const count = benefit.limit ?? 0
  switch (benefit.code) {
    case 'hotel_upgrade':
      return `${quantityWord(benefit, count)} free room or package ${count === 1 ? 'upgrade' : 'upgrades'}`
    case 'lounge_pass':
      return `${quantityWord(benefit, count)} free airport lounge ${count === 1 ? 'pass' : 'passes'}`
    case 'airport_transfer':
      return `${quantityWord(benefit, count)} free airport chauffeur ${count === 1 ? 'transfer' : 'transfers'}`
    case 'tour_exp_credit': {
      const prefix = benefit.value ? `$${benefit.value.amount}` : quantityWord(benefit, count)
      return `${prefix} tour ${count === 1 ? 'credit' : 'credits'}`
    }
    case 'travelshoot_credit': {
      const prefix = benefit.value ? `$${benefit.value.amount}` : quantityWord(benefit, count)
      return `${prefix} TravelShoot ${count === 1 ? 'voucher' : 'vouchers'}`
    }
    case 'phone_support':
      return '24/7 priority phone support'
    case 'discounted_insurance':
      return `${benefit.value?.amount ?? 0}% off travel insurance`
    case 'esim_package':
      return `${benefit.value?.amount ?? 0}GB travel eSIM per international trip`
    default:
      return undefined
  }
}
